
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CoursesAdmin from "@/components/admin/CoursesAdmin";
import BlogAdmin from "@/components/admin/BlogAdmin";
import ProjectsAdmin from "@/components/admin/ProjectsAdmin";
import ContactMessagesAdmin from "@/components/admin/ContactMessagesAdmin";
import UserManagement from "@/components/admin/UserManagement";
import PaymentSettingsAdmin from "@/components/admin/PaymentSettingsAdmin";
import TestimonialsAdmin from "@/components/admin/TestimonialsAdmin";
import NewsletterAdmin from "@/components/admin/NewsletterAdmin";
import AdminInsights from "@/components/admin/AdminInsights";
import AIToolsUsageAdmin from "@/components/admin/AIToolsUsageAdmin";
import NavbarLinksAdmin from "@/components/admin/NavbarLinksAdmin";
import {
  BarChart3,
  BookOpen,
  FileText,
  FolderKanban,
  MessageSquare,
  Mail,
  DollarSign,
  Star,
  Users,
  Zap,
  Link
} from "lucide-react";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("insights");

  const handleTabChange = (value: string) => {
    setActiveTab(value);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="text-3xl font-bold mb-8 gradient-text">Admin Dashboard</h1>

      <Tabs value={activeTab} onValueChange={handleTabChange} className="space-y-6">
        <TabsList className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-11 gap-2 p-2 bg-muted/80 backdrop-blur-sm rounded-xl">
          <TabsTrigger value="insights" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <BarChart3 className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Insights</span>
          </TabsTrigger>
          <TabsTrigger value="courses" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <BookOpen className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Courses</span>
          </TabsTrigger>
          <TabsTrigger value="blog" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <FileText className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Blog</span>
          </TabsTrigger>
          <TabsTrigger value="projects" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <FolderKanban className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Projects</span>
          </TabsTrigger>
          <TabsTrigger value="messages" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <MessageSquare className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Messages</span>
          </TabsTrigger>
          <TabsTrigger value="newsletter" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <Mail className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Newsletter</span>
          </TabsTrigger>
          <TabsTrigger value="payments" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <DollarSign className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Payments</span>
          </TabsTrigger>
          <TabsTrigger value="testimonials" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <Star className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Testimonials</span>
          </TabsTrigger>
          <TabsTrigger value="users" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <Users className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Users</span>
          </TabsTrigger>
          <TabsTrigger value="ai-tools" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <Zap className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">AI Tools</span>
          </TabsTrigger>
          <TabsTrigger value="navigation" className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <Link className="mr-2 h-4 w-4" />
            <span className="hidden sm:inline">Navigation</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="insights" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <AdminInsights />
        </TabsContent>

        <TabsContent value="courses" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <CoursesAdmin />
        </TabsContent>

        <TabsContent value="blog" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <BlogAdmin />
        </TabsContent>

        <TabsContent value="projects" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <ProjectsAdmin />
        </TabsContent>

        <TabsContent value="messages" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <ContactMessagesAdmin />
        </TabsContent>

        <TabsContent value="newsletter" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <NewsletterAdmin />
        </TabsContent>

        <TabsContent value="payments" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <PaymentSettingsAdmin />
        </TabsContent>
        
        <TabsContent value="testimonials" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <TestimonialsAdmin />
        </TabsContent>

        <TabsContent value="users" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <UserManagement />
        </TabsContent>

        <TabsContent value="ai-tools" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <AIToolsUsageAdmin />
        </TabsContent>

        <TabsContent value="navigation" className="p-6 border rounded-xl bg-card/50 backdrop-blur-sm shadow-sm">
          <NavbarLinksAdmin />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminDashboard;
